// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"571":"stencil-polyfills-dom","952":"stencil-polyfills-css-shim"}[chunkId] || chunkId) + "." + {"207":"bd754553","291":"8cc55035","355":"b7087e79","400":"2c86354a","401":"5108acac","571":"24a0a4fe","702":"512d5ee6","762":"d414a45d","952":"214e40d9"}[chunkId] + ".chunk.js";
};